import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";

const Footer = () => {
  const { Headers, isHeader, cartItems, AllProducts, AllCategoriess } =
    useBlogContext();
  const formatContactNumber = (number) => {
    const digits = String(number || "").replace(/\D/g, "");
    return digits.length === 10 ? `91${digits}` : digits;
  };
  const callNumber = formatContactNumber(Headers?.phone);
  const whatsappNumber = formatContactNumber(Headers?.whatsapp || Headers?.phone);
  const callHref = callNumber ? `tel:+${callNumber}` : "#";
  const whatsappHref = whatsappNumber ? `https://api.whatsapp.com/send/?phone=%2B${whatsappNumber}` : "#";

  return (
    <>


    {!isHeader && (
                                    <div className="fixed-calls d-md-none">
                                      <a
                                        href={whatsappHref}
                                        className="cat-wa-btn"
                                        target="_blank" rel="noreferrer"
                                      >
                                        <i className="ri-whatsapp-fill" /> WhatsApp
                                      </a>
                                      <Link to={callHref} className="cat-call-btn">
                                        <i className="ri-phone-line" /> Call Now
                                      </Link>
                                    </div>
                                  )}


      {/* Footer */}
      <footer className="footer bg-primary " >
        <div className="footer-top py-4 py-lg-10 ">
          <div className="container">
            

            <div className="row g-4 g-lg-10">
              <div className="col-lg-9">
                <div className="row g-4">
                  {isHeader
                    ? // Display loading skeletons while data is being fetched
                      Array.from({ length: 12 }).map((_, index) => (
                        <div className="nav-item col-4" key={index}>
                          <div
                            className="skeleton mt-1"
                            style={{
                              height: 22,
                              width: 100,
                              borderRadius: 5,
                            }}
                          ></div>
                        </div>
                      ))
                    : Headers.footer !== undefined &&
                      Headers.footer.slice(0, 4).map((item, index) => (
                        <div className="col-12 col-md-4" key={index}>
                          <div className="widget widget-links">
                            <h4 className="widget-title fw-medium h6 text-white fw-bold">
                              {item.text}
                            </h4>
                            <ul className="widget-list">
                              {item.children.map((childItem, childIndex) => (
                                <li
                                  className="widget-list-item"
                                  key={childIndex}
                                >
                                  <Link
                                    className="widget-list-link text-white"
                                    to={childItem.link}
                                  >
                                    {childItem.text}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-4">
                   
                  <h4 className="widget-title fw-medium h6 text-white fw-bold">Contact Us</h4>
                </div>
                <div className="mb-4">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <i
                        className="text-white ri-phone-fill "
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-white"> For Appointment  </h6>
                        <a
                          href={callHref}
                          className="nav-link-base h6 fw-light text-white"
                        >
                          +91 {Headers.phone}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
             
                <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-white ri-mail-fill"
                       style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-white"> Email</h6>
                        <a
                          href={`mailto:${Headers.email}`}
                          className="nav-link-base h6 fw-light text-white "
                        >
                          {Headers.email}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                   <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-white ri-map-2-fill"
                        style={{ fontSize: "1.5rem" }}
                      />
                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-1 text-white font-weight-bold h6">
                          Address 
                        </h6>
                        <span className="h6 text-white fw-light"> {Headers.address}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {Headers.footer !== undefined &&
                      Headers.footer.slice(4, 100).map((item, index) => (
                        <div className="col-12 col-md-3" key={index}>
                          <div className="widget widget-links">
                            <h4 className="widget-title fw-medium h5 text-white fw-bold">
                              {item.text}
                            </h4>
                            <ul className="widget-list">
                              {item.children.map((childItem, childIndex) => (
                                <li
                                  className="widget-list-item"
                                  key={childIndex}
                                >
                                  <Link
                                    className="widget-list-link text-white"
                                    to={childItem.link}
                                  >
                                    {childItem.text}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom border-top py-4 bg-black "  >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-3 text-center text-lg-start">
                <ul className="list-inline mb-0 d-none">
                  <li className="list-inline-item">
                    <a className="link-accent fs-xl" href="#">
                      <i className="ri-facebook-line" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="link-danger fs-xl" href="#">
                      <i className="ri-google-line" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="link-info fs-xl" href="#">
                      <i className="ri-twitter-line" />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-lg-6 text-center">
                <p
                 
                  className="nav-link-base fs-sm text-white fw-light m-0 "
                >
                  {!isHeader && Headers.footer_credit} 
                 <span className="d-none"> {' | '}  Design by <a href="https://seotowebdesign.com/" target="_blank" className="text-white fw-bold" >  Seo To Webdesign </a> </span>
                </p>
              </div>

              {/* <div className="col-12 col-lg-3 text-center text-lg-end mt-3 mt-lg-0">
            <img
              className="d-inline-block align-middle"
              src="assets/img/shop/cards.png"
              width={246}
              alt="Cerdit Cards"
            />
          </div> */}
            </div>
          </div>
        </div>
      </footer>

     



    </>
  );
};

export default Footer;
